<button
  type="button"
  class="btn p-0"
  (click)="copy()"
  aria-label="Copy"
>
  <i class="icon-copy"></i>
</button>
